import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';
import { createTextChangeRange } from 'typescript';

@Component
export class CartItemCount extends ThemeComponent {

    init() {
        // Subscribe to cart change events
        this.$subscribe(cart.onChange, () => {
            const itemCount = cart.getCartItemCount();
            if (itemCount <= 0) {
                this.classList.add('cart-item-count--hidden');
            } else {
                this.classList.remove('cart-item-count--hidden');
            }
            this.innerHTML = itemCount.toString();
        });
    }
}
